const doc = [({"da":({"js":({"admin":({"activities":({"billing":({"billing":"Fakturering", "the_activity_was_saved":"Aktiviteten blev gemt"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;